
export default function formattedDate(name) {

    let date = new Date(name)

    let month = date.getMonth() + 1
    if (month < 10) { month = '0' + month }

    let day = date.getDate()
    if (day < 10) { day = '0' + day }

    let formatted_date = date.getFullYear() + "-" + month + "-" + day

    return formatted_date

}

